<script setup lang="ts">
import { ALButton, ALModal } from "@af-lib/vue-ui"
import { ref } from "vue"
import { useConfigStore } from "@/stores/config"
import { useSessionStorage } from "@/helpers/useSessionStorage"

const configStore = useConfigStore()
const { getSessionItem } = useSessionStorage()

function onValid() {
  let url = `${configStore.urls.integration_url}/${getSessionItem("iframe_token")}/assessment?v=af`
  if (getSessionItem("version")) {
    url = `${configStore.urls.integration_url_v1}/${getSessionItem("iframe_token")}?v=af`
  }

  if (getSessionItem("goto_param")) {
    url += `&id=${getSessionItem("goto_param")}`
  }
  if (getSessionItem("target_uuid")) {
    url += `&target_uuid=${getSessionItem("target_uuid")}`
  }
  if (getSessionItem("sharepool_uuid")) {
    url += `&sharepool_uuid=${getSessionItem("sharepool_uuid")}`
  }
  if (getSessionItem("redirect_url")) {
    url += `&redirect_url=${getSessionItem("redirect_url")}`
  }
  if (getSessionItem("version")) {
    url += `&version=${getSessionItem("version")}`
  }

  window.open(url, "_blank")
}

const isOpen = ref(true)
</script>

<template>
  <ALModal
    v-model="isOpen"
    size="l"
    variant="default"
    :isClosable="false"
    headerIcon="fa-thin fa-door-open"
  >
    <template #header>
      <span class="text-af-grey-800 font-bold">
        {{ $t("assessment.iframe.blocked.title") }}
      </span>
    </template>

    <template #content>
      <p class="text-af-grey-800 text-base font-light">
        {{ $t("assessment.iframe.blocked.body") }}
      </p>
    </template>

    <template #footer>
      <ALButton @click="onValid">
        {{ $t("assessment.iframe.blocked.cta") }}
      </ALButton>
    </template>
  </ALModal>
</template>
